/**
 * SCHOOL
 *
 * @date 2022-03-24
 */


(function ($) {
  const SCHOOL = window.SCHOOL || {};

  SCHOOL.Enquete = function () {
    // 初期化
    const _init = function () {
      setAccordion();
      classFeatureCarousel();
      $(window).on('resize', classFeatureCarousel);
    };

    // アコーディオン
    const setAccordion = () => {
      const $accordionBtn = $('.js_accordion_btn');
      const $accordionBody = $('.js_accordion_body');
      if (!$accordionBtn.length) return;

      const mediaCheck = () => {
        if (window.matchMedia('(min-width: 768px)').matches) {
          $accordionBtn.removeAttr('aria-expanded');
          $accordionBody.removeAttr('aria-hidden');
        } else {
          $accordionBtn.attr('aria-expanded', false);
          $accordionBody.attr('aria-hidden', true);
        }
      }
      mediaCheck();

      const changeAriaProperty = ($btn, $body, state) => {
        const $selectedValue = state ? false : true;
        $btn.attr('aria-expanded', $selectedValue);
        $body.attr('aria-hidden', state);
      };

      const toggleAction = $body => {
        $body.stop().slideToggle();
      };

      $accordionBtn.on('click', function () {
        const $this = $(this);
        const $accordionBody = $(this).prev('.js_accordion_body');
        const $state = $(this).attr('aria-expanded') === 'true' ? true : false;
        toggleAction($accordionBody);
        changeAriaProperty($this, $accordionBody, $state);
      });
    };

    const classFeatureCarousel = () => {
      const $carousel = $('.js_featureSlider');
      if (!$carousel.length) return;
      if (window.matchMedia('(min-width: 768px)').matches) {
        $('.js_featureSlider.slick-initialized').slick('unslick');
        return;
      } else {
        $carousel.not('.slick-initialized').each(function (index) {

          $carousel.eq(index).slick({
            responsive: [
              {
                breakpoint: 768, // 〜767px
                settings: {
                  infinite: true,
                  centerPadding: '24.15%',
                  centerMode: true,
                  slidesToShow: 1,
                  arrows: false,
                  centerMode: false,
                  infinite: false,
                  swipeToSlide: true,
                  // variableWidth: true,
                  outerEdgeLimit: true,
                }
              }
            ],
          });
        });
      }
    };


    return {
      init: _init
    };
  }();

  SCHOOL.Enquete.init();
})(jQuery);
